var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgBook = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M24 47.261C36.847 47.261 47.26 36.847 47.26 24S36.847.738 24 .738.738 11.153.738 24 11.153 47.26 24 47.26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M24 15.509a2.96 2.96 0 0 1 2.954-2.954h8.861M24 36.923a2.96 2.96 0 0 1 2.954-2.954h8.861M24 15.509a2.963 2.963 0 0 0-2.954-2.954h-8.861M24 36.923a2.963 2.963 0 0 0-2.954-2.954h-8.861M26.216 30.645h8.861V12.922M21.784 30.645h-8.861V12.922M24 31.383V13.66"
  })));
};
const Memo = /*#__PURE__*/memo(SvgBook);
export default Memo;